import { render, staticRenderFns } from "./BookingClients.vue?vue&type=template&id=3d041e94&scoped=true"
import script from "./BookingClients.vue?vue&type=script&lang=js"
export * from "./BookingClients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d041e94",
  null
  
)

export default component.exports